import React, { Component, Fragment } from 'react';
import { withAsyncActions } from 'react-async-client';
import Translate from 'react-translate-component';
import { Form } from 'antd';

import { formItemLayout, wrapCellFormItem } from 'constants/formItemLayout';
import { getMetroPosition } from 'actions/asyncActions';

@withAsyncActions({
    getMetroPosition: getMetroPosition
        .withParams(() => ({ ACO: true }))
        .withPayload(({ cell, city, routeType }) => cell ? ({ id: cell, city, routeType }) : null)
        .withOptions({ dispatchOnMount: true, resetOnUnmount: true }),
})
class CellFields extends Component {
    renderField = (fieldName) => {
        const { getMetroPosition: { data } } = this.props;
        const value = data[fieldName];

        return value ? (
            <Form.Item
                labelCol={formItemLayout.labelCol}
                wrapperCol={formItemLayout.wrapperCol}
                label={<Translate content={`metro.request.${fieldName}`} component='span' />}
            >
                <div className='approval-route-view'>
                    {value}
                </div>
            </Form.Item>
        ) : null;
    }

    render() {
        const { getMetroPosition: { meta } } = this.props;

        return meta.success ? (
            <Fragment>
                { this.renderField('position') }
                { this.renderField('positionEngl') }
                { this.renderField('positionGrade') }
                { this.renderField('positionLevel') }
                { this.renderField('bonusScheme') }
                { this.renderField('bonusSchemePercent') }
                { this.renderField('familyDMS') }
                { this.renderField('companyCar') }
                { this.renderField('travellingWork') }
                { this.renderField('liabilityContract') }
                { this.renderField('responsibilities') }
            </Fragment>
        ) : meta.error ? (
            <Form.Item wrapperCol={wrapCellFormItem}>
                <Translate content='metro.request.positionError' />
            </Form.Item>
        ) : null;
    }
}

export default CellFields;
